import { createFileRoute } from '@tanstack/react-router'
import Dashboard from '@/features/dashboard'

// Route chính cho dashboard
export const Route = createFileRoute('/_authenticated/dashboard/')({
  component: Dashboard,
}) 